<template>
  <div class="the_header">
    <div class="button">
      <!-- Bouton export -->
      <Boutton
        background="#312879"
        color="#fff"
        label="Exporter"
        @click="handleExport"
        :charge="charge"
      >
        Exporter
      </Boutton>

      <!-- Export Excel caché -->
      <export-excel
        v-if="readyToExport && json_data.length > 0"
        ref="excelExport"
        class="hidden"
        :data="json_data"
        :fields="json_fields"
        worksheet="Entreprises"
        name="Commerce.xls"
      />
    </div>
  </div>
</template>

<script>
import { exportExcelCommerce } from '@/component/cdevs/allFunctions'
import Boutton from '../../../component/helper/add/button.vue';

export default {
  name: 'ExcelCommerce',
  components: {
    Boutton,
  },
  data() {
    return {
      charge: false,
      readyToExport: false,
      json_fields: {
        'No': 'i',
        'Entreprise': 'e',
        'Gérant': 'g',
        'Téléphone': 't',
        'Taille': 'taille',
        'Catégorie': 'c',
        'SDF partenaires': 'sdf',
        "Date d’inscription": 'date'
      },
      json_data: []
    }
  },

  methods: {
async handleExport() {
  try {
    console.log("handleExport déclenché ✅")
    this.charge = true
    this.json_data = []
    this.readyToExport = false

    const response = await exportExcelCommerce()
    console.log("API brut:", response)

    const raw = response?.data || response
    console.log("API data extrait:", raw)

    let freshData = []
    if (Array.isArray(raw)) {
      freshData = raw
    } else if (Array.isArray(raw.data)) {
      freshData = raw.data
    }

    if (freshData.length === 0) {
      console.warn("⚠️ Aucun enregistrement reçu")
      return
    }

    this.prepareExcelData(freshData)
    this.readyToExport = true
    await this.$nextTick()
    this.downloadExcel()

  } catch (error) {
    console.error("Erreur lors de l'export:", error)
    this.$toast?.error("Erreur pendant l’export")
  } finally {
    this.charge = false
  }
},

    prepareExcelData(data) {
      this.json_data = data.map((item, index) => ({
        i: index + 1,
        e: item["Nom de l’entreprise"] ?? item.nomEntreprise ?? "",
        g: item["Gérant"] ?? item.gerant ?? "",
        t: item["Téléphone"] ?? item.telephone ?? "",
        taille: item["Taille"] ?? item.taille ?? "",
        c: item["Catégorie"] ?? item.categorie ?? "",
        sdf: item["SDF partenaires"] ?? item.sdf ?? "",
        date: item["Date d’inscription"] ?? item.date ?? ""
      }))
      console.log("json_data construit ✅", this.json_data.slice(0, 5)) // on affiche juste 5
    },

    downloadExcel() {
      if (this.$refs.excelExport) {
        this.$refs.excelExport.$el.click()
        console.log("📂 Export lancé")
      }
      setTimeout(() => (this.readyToExport = false), 1000)
    }
  }
}
</script>


<style>
.bgexport {
  background: #312879;
  height: 50px;
  width: 150px;
  border-radius: 10px;
}
</style>